import { Calculation } from '../../../../../shared/components/Form/final-form-calculate';

export function emailTemplateUpdater(resetInitialTemplateValues = true): Calculation {
    return {
        field: 'emailTemplate',
        updates: (value: number, fieldName: string, allValues: any) => {
            const updates: any = {};

            if (value) {
                const emailTemplate = allValues.templates.find(t => t.id === Number(value));

                if (emailTemplate) {
                    return {
                        emailOptions: {
                            ...allValues.emailOptions,
                            subject: emailTemplate.subject,
                            body: emailTemplate.body,
                            saveSubject: false,
                            saveBody: false,
                        },
                    };
                }
            } else if (resetInitialTemplateValues) {
                // clear both subject and body
                return {
                    emailOptions: {
                        ...allValues.emailOptions,
                        subject: '',
                        body: '',
                        saveSubject: false,
                        saveBody: false,
                    },
                };
            } else {
                return {
                    emailOptions: {
                        ...allValues.emailOptions,
                        ...allValues.initialEmailTemplate,
                    },
                };
            }

            return updates;
        },
    };
}
